'use strict';
import { hasAccess } from 'Resources/parsers/product';

angular.module('upResources').service('ParseProduct', [
	'AppService',
	function (AppService) {
		return function (product) {
			const self = AppService.getSelf();
			const productCategories = AppService.getProductCategories();
			product.$hasAccess = hasAccess(self, product, productCategories);
			return product;
		};
	}
]);
